import { render } from "./CoverArtistInfos.vue?vue&type=template&id=26af7220"
import script from "./CoverArtistInfos.vue?vue&type=script&lang=js"
export * from "./CoverArtistInfos.vue?vue&type=script&lang=js"

import "./CoverArtistInfos.vue?vue&type=style&index=0&id=26af7220&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__